// Posts du canal (#141, 15/09) : logique pure de la page, testée sous node (scratchpad liens_perso/test_canal_posts.py).
export const CANAL_PHOTO_MAX = 10 * 1048576;
export const CANAL_VIDEO_MAX = 50 * 1048576;
const PHOTO_EXTS = ['jpg', 'jpeg', 'png', 'webp'];
const VIDEO_EXTS = ['mp4', 'mov', 'm4v'];

// Même règle que le serveur (extension + poids). Renvoie un message court, ou '' si le fichier passe.
export function refusFichier(f) {
  if (!f) return 'Aucun fichier';
  const nom = String(f.name || '');
  const ext = nom.includes('.') ? nom.split('.').pop().toLowerCase() : '';
  const video = VIDEO_EXTS.includes(ext);
  if (!video && !PHOTO_EXTS.includes(ext)) return 'Photo (jpg, png, webp) ou vidéo (mp4, mov) seulement';
  if (video && f.size > CANAL_VIDEO_MAX) return 'Vidéo trop lourde : 50 Mo max';
  if (!video && f.size > CANAL_PHOTO_MAX) return 'Photo trop lourde : 10 Mo max';
  return '';
}

// URL du bouton quand on choisit un canal : lien de sa modèle si le champ est vide ou contient encore
// l'ancien pré-remplissage. Une URL tapée à la main n'est jamais écrasée.
export function urlBoutonPourCanal(urlActuelle, ancienPreRempli, lienModele) {
  const actuelle = String(urlActuelle || '').trim();
  const lien = String(lienModele || '').trim();
  if (actuelle && actuelle !== String(ancienPreRempli || '').trim()) return { url: urlActuelle, pre: ancienPreRempli || '' };
  return { url: lien, pre: lien };
}

// Bouton incomplet : texte sans URL, ou URL tapée sans texte. L'URL pré-remplie seule (texte vide) = post sans bouton.
export function boutonIncomplet(texte, url, lienModele) {
  const t = String(texte || '').trim();
  const u = String(url || '').trim();
  if (!t && u && u === String(lienModele || '').trim()) return false;
  return Boolean(t) !== Boolean(u);
}

export function lienDuCanal(bot, modeles) {
  if (!bot || !bot.account_id) return '';
  const m = (modeles || []).find(x => x.id === bot.account_id);
  return (m && m.lien_telegram) || '';
}

// Canal à sélectionner : celui demandé s'il existe, sinon le dernier choisi, sinon le premier.
export function canalAChoisir(bots, demande, memorise) {
  const ids = (bots || []).map(b => b.id);
  if (demande && ids.includes(demande)) return demande;
  if (memorise && ids.includes(memorise)) return memorise;
  return ids[0] || '';
}

const CLE_CANAL = 'chathub.canalPosts.dernierCanal';
export function lireDernierCanal() {
  try { return window.localStorage.getItem(CLE_CANAL) || ''; } catch (e) { return ''; }
}
export function memoriserCanal(id) {
  try { if (id) window.localStorage.setItem(CLE_CANAL, id); } catch (e) { /* stockage indisponible */ }
}

// 16/09 — « Modifier » un post programmé et vignettes de la file.
// Date du serveur (UTC, souvent sans « Z ») → valeur d'un champ datetime-local à l'heure du navigateur
// (même heure que celle relue par new Date(champ) à l'enregistrement).
export function versChampDate(iso) {
  if (!iso) return '';
  const s = String(iso);
  const d = new Date(/Z$|[+-]\d{2}:?\d{2}$/.test(s) ? s : `${s}Z`);
  if (Number.isNaN(d.getTime())) return '';
  return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 16);
}

// Adresse d'un média : chemin du serveur (/api/uploads/…) préfixé par l'adresse du backend ; http(s), blob: et data: tels quels.
export function srcMedia(u, base) {
  if (!u) return '';
  if (/^(https?:|blob:|data:)/i.test(u)) return u;
  return `${base || ''}${u}`;
}

// Ligne mise à jour sur place après « Enregistrer » (pas de rechargement de la page).
export function remplacerLigne(rows, doc) {
  return (rows || []).map(r => (doc && r.id === doc.id ? doc : r));
}

// ── 17/09 : SONDAGES (sendPoll) — mêmes limites que le serveur, tirées de la doc Bot API 10.3 ──
// Longueurs comptées comme Telegram : unités UTF-16 (= String.length en JavaScript ; un emoji compte souvent pour 2).
export const SONDAGE = { question: 300, optionsMin: 1, optionsMax: 12, option: 100, explication: 200, lignesExplication: 2, dureeMin: 5, dureeMax: 2628000 };
export const SONDAGE_OPTIONS_ECRAN = 2;   // le formulaire propose toujours au moins 2 options (Telegram en accepte 1)
export const DUREES_SONDAGE = [[0, 'Jamais'], [3600, '1 h'], [21600, '6 h'], [43200, '12 h'], [86400, '24 h'], [259200, '3 jours'], [604800, '7 jours'], [2592000, '30 jours']];

export function sondageVide() {
  return { question: '', options: ['', ''], multiple: false, quiz: false, bonnes: [], explication: '', duree_s: 0 };
}

// Post « sondage » renvoyé par le serveur → valeurs du formulaire « Modifier ».
export function sondageDepuisPost(r) {
  const s = (r && r.sondage) || {};
  const options = (s.options || []).slice();
  while (options.length < SONDAGE_OPTIONS_ECRAN) options.push('');
  return { question: s.question || '', options, multiple: Boolean(s.multiple), quiz: Boolean(s.quiz),
    bonnes: (s.bonnes || []).slice(), explication: s.explication || '', duree_s: s.duree_s || 0 };
}

// Première erreur bloquante ('' si le sondage peut partir). Même ordre et mêmes règles que _canal_sondage_controles.
export function erreurSondage(s) {
  const L = SONDAGE;
  const question = String((s && s.question) || '').trim();
  if (!question) return 'Écris la question du sondage.';
  if (question.length > L.question) return `Question trop longue : ${L.question} caractères au maximum (Telegram).`;
  const options = ((s && s.options) || []).map(o => String(o || '').trim());
  if (options.length < L.optionsMin || options.length > L.optionsMax) return `Entre ${L.optionsMin} et ${L.optionsMax} options (limite Telegram).`;
  for (let i = 0; i < options.length; i += 1) {
    if (!options[i]) return `Option ${i + 1} vide : remplis-la ou retire-la.`;
    if (options[i].length > L.option) return `Option ${i + 1} trop longue : ${L.option} caractères au maximum (Telegram).`;
  }
  if (new Set(options).size !== options.length) return 'Deux options sont identiques : change l\'une des deux.';
  if (s.quiz) {
    const bonnes = Array.from(new Set(s.bonnes || []));
    if (!bonnes.length) return 'Quiz : coche la bonne réponse.';
    if (bonnes.some(i => i < 0 || i >= options.length)) return 'Quiz : la bonne réponse doit être une des options.';
    if (!s.multiple && bonnes.length !== 1) return 'Quiz à réponse unique : coche une seule bonne réponse (ou active les choix multiples).';
    const ex = String(s.explication || '').trim();
    if (ex.length > L.explication) return `Explication trop longue : ${L.explication} caractères au maximum (Telegram).`;
    if ((ex.match(/\n/g) || []).length > L.lignesExplication) return `Explication : ${L.lignesExplication} retours à la ligne au maximum (Telegram).`;
  }
  const d = Number(s.duree_s || 0);
  if (d && (d < L.dureeMin || d > L.dureeMax)) return 'Fermeture automatique : entre 5 secondes et 30 jours (2 628 000 s, limite Telegram).';
  return '';
}

// Corps JSON envoyé au serveur (création : + bot_id).
export function corpsSondage(s, { bouton_texte = '', bouton_url = '', scheduled_at = '', bot_id } = {}) {
  const corps = { question: String(s.question || ''), options: (s.options || []).map(o => String(o || '')), multiple: Boolean(s.multiple),
    quiz: Boolean(s.quiz), bonnes: s.quiz ? (s.bonnes || []).slice().sort((a, b) => a - b) : [], explication: s.quiz ? String(s.explication || '') : '',
    duree_s: Number(s.duree_s) || null, bouton_texte, bouton_url, scheduled_at };
  if (bot_id !== undefined) corps.bot_id = bot_id;
  return corps;
}

// Quiz : cocher une bonne réponse (une seule sans choix multiples). Retirer une option décale les bonnes réponses.
export function basculerBonne(s, i) {
  const deja = (s.bonnes || []).includes(i);
  if (!s.multiple) return { ...s, bonnes: deja ? [] : [i] };
  return { ...s, bonnes: deja ? s.bonnes.filter(x => x !== i) : [...(s.bonnes || []), i].sort((a, b) => a - b) };
}
export function retirerOption(s, i) {
  return { ...s, options: s.options.filter((_, k) => k !== i), bonnes: (s.bonnes || []).filter(x => x !== i).map(x => (x > i ? x - 1 : x)) };
}

// Résumé d'une ligne : « 3 options · quiz · choix multiples · se ferme après 1 h ».
export function resumeSondage(s) {
  const x = s || {};
  const morceaux = [`${(x.options || []).length} option${(x.options || []).length > 1 ? 's' : ''}`];
  if (x.quiz) morceaux.push('quiz');
  if (x.multiple) morceaux.push('choix multiples');
  const d = DUREES_SONDAGE.find(([v]) => v && v === x.duree_s);
  if (x.duree_s) morceaux.push(`se ferme après ${d ? d[1] : `${x.duree_s} s`}`);
  return morceaux.join(' · ');
}

// ── 17/09 : VOCAUX (sendVoice) — le serveur convertit tout audio en OGG/Opus mono ──
export const AUDIO_EXTS = ['mp3', 'm4a', 'aac', 'wav', 'ogg', 'oga', 'opus', 'flac', 'webm', 'amr', '3gp', 'caf'];
export const AUDIO_MAX = 50 * 1048576;
export function refusAudio(f) {
  if (!f) return 'Aucun fichier';
  const nom = String(f.name || '');
  const ext = nom.includes('.') ? nom.split('.').pop().toLowerCase() : '';
  if (!AUDIO_EXTS.includes(ext)) return 'Fichier audio seulement : MP3, M4A, WAV, OGG, OPUS, AAC ou FLAC';
  if (f.size > AUDIO_MAX) return 'Audio trop lourd : 50 Mo max';
  return '';
}
// 3 → « 0:03 » ; 65 → « 1:05 » ; 3725 → « 1:02:05 ».
export function dureeTexte(secondes) {
  const s = Math.max(0, Math.round(Number(secondes) || 0));
  const h = Math.floor(s / 3600); const m = Math.floor((s % 3600) / 60); const r = String(s % 60).padStart(2, '0');
  return h ? `${h}:${String(m).padStart(2, '0')}:${r}` : `${m}:${r}`;
}
